<template>
  <div>
    <a-card style="margin-bottom: 10px">
      <div class="filter-section">
        <a-form layout="inline" ref="form" :model="form">
          <a-form-item name="chineseInstructions">
            <a-input style="width: 200px" placeholder="请输入名称" v-model:value="form.chineseInstructions" autocomplete="off">
              <template v-slot:suffix><search-outlined type="user"/></template>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button @click="resetForm">重置</a-button>
            <a-button type="primary" @click="getData()">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <a-card>
      <div class="table-title">
        <p class="table-name">
          标签管理
        </p>
        <a-button
          type="primary"
          @click="openDialog('add')"
          v-if="btnPerm.tag.add.indexOf(currentRole.roleId) !== -1"
        >
          添加标签
        </a-button>
      </div>
      <br>
      <a-table
        :columns="columns"
        :data-source="tableData"
        rowKey="id"
        :pagination="false">
        <template v-slot:time="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:companyId="{ text }">
          {{ getCompanyName(text) }}
        </template>
        <template v-slot:teamId="{ text }">
          {{ getTeamName(text) }}
        </template>
        <template v-slot:userId="{ text }">
          {{ getUserName(text) }}
        </template>
        <template v-slot:action="{ record }">
          <span class="gap-btn">
            <a @click="openDialog('edit', record)">编辑</a>
          </span>
          <span class="gap-btn">
            <a @click="handleDelete(record)">删除</a>
          </span>
        </template>
      </a-table>
      <br>
      <a-pagination
        :current="page.currentPage"
        show-quick-jumper
        :pageSize="10"
        :total="total"
        :show-total="total => `共 ${total} 条`"
        @change="getData"
      ></a-pagination>
    </a-card>
    <EditDialog ref="editDialog"
      :dialogType="dialogType"
      :currentItem="currentItem"
      @update="getData()">
    </EditDialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { SearchOutlined } from '@ant-design/icons-vue'
import { getTagLabelByPage, deleteTagLabel } from '@/api/tagLabel'
import { getDateTime, getCompanyName, getTeamName, getUserName } from '@/filters'
import EditDialog from './EditDialog'
import config from '@/config'
const columns = [
  {
    title: '名称',
    dataIndex: 'chineseInstructions'
  },
  {
    title: '团队',
    dataIndex: 'teamId',
    slots: { customRender: 'teamId' }
  },
  {
    title: '创建人',
    dataIndex: 'createUserId',
    slots: { customRender: 'userId' }
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    slots: { customRender: 'time' }
  },
  {
    title: '操作',
    slots: { customRender: 'action' }
  }
]

export default {
  components: {
    SearchOutlined,
    EditDialog
  },
  data () {
    return {
      btnPerm: config.btnPerm,
      form: {
        name: ''
      },
      tableData: [],
      columns,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dialogType: 'add',
      currentItem: {}
    }
  },
  computed: {
    ...mapState(['currentRole'])
  },
  mounted () {
    this.getData()
  },
  methods: {
    getDateTime,
    getCompanyName,
    getTeamName,
    getUserName,
    resetForm () {
      this.$refs.form.resetFields()
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      getTagLabelByPage({ ...this.page, ...this.form }).then(res => {
        const data = res.data.map.data
        this.tableData = data.rows
        this.total = data.total
      })
    },
    openDialog (type, item) {
      this.dialogType = type
      if (type === 'edit') {
        this.currentItem = item
      } else {
        this.currentItem = {}
      }
      this.$refs.editDialog.open()
    },
    handleDelete (record) {
      this.$confirm({
        title: '删除标签',
        content: '确认删除标签？',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          deleteTagLabel(record.id).then(res => {
            this.$message.success('已删除')
            this.getData()
          })
        },
        onCancel () {
          console.log('cancel')
        }
      })
    }
  }
}
</script>
<style>

</style>
